import React, { useState, useEffect } from 'react';
import EditFrequency from './edit_frequency';
import { useAuth } from '../../../providers/auth_provider';
import axios from 'axios';

export default function Account({ frequencyData }) {
    const { token } = useAuth();
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const getCategories = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/category/all`, {
                headers: {
                    'Content-Type': 'application/json',
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`
                }
            })
            setCategories(response.data.categories);
        }
        getCategories();

    }, []);


    return (
        <div className="card card-action mb-6">
            <div className="card-header align-items-center">
                <div className="w-100 order-0 order-md-1">
                    <h5 className="pb-4 border-bottom my-4">Frequency Details</h5>
                    <div className="info-container">
                        <ul className="list-unstyled mb-6">
                            <li className="mb-2">
                                <span className="fw-medium text-heading me-2">Status:</span>
                                <span className={`text-capitalize badge rounded-pill ${frequencyData?.status === 'active' ? 'bg-label-success' : frequencyData?.status === 'inactive' ? 'bg-label-warning' : 'bg-label-danger'}`}>
                                    {frequencyData?.status}
                                </span>
                            </li>
                            <li className="mb-2">
                                <span className="fw-medium text-heading me-2">Mode:</span>
                                <span className="text-capitalize">{frequencyData?.subscription_type}</span>
                            </li>
                            {frequencyData?.subscription_type === 'free' ? (
                                <li className="mb-2">
                                    <span className="fw-medium text-heading me-2">Free Time:</span>
                                    {frequencyData ? frequencyData?.frequency_details[0]?.no_of_days_for_free + ' Days'
                                        : 'No Frequency Details Available'}
                                </li>
                            ) : null}

                            <li className="mb-2">
                                <span className="fw-medium text-heading me-2">Category:</span>
                                {categories?.map((cat, index) => (
                                    <span className="text-capitalize" key={index}>
                                        {frequencyData?.category_id === cat.id ? cat.name : ''}
                                    </span>
                                ))}
                            </li>
                            <li className="mb-2">
                                <span className="fw-medium text-heading me-2">Description:</span>
                                {categories?.map((cat, index) => (
                                    <span key={index}>
                                        {frequencyData?.category_id === cat.id ? cat.description : ''}
                                    </span>
                                ))}
                            </li>
                        </ul>
                        <div className="d-flex justify-content-center">
                            <button
                                className="btn btn-primary me-4"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasEditFrequency">
                                <i className="ri-add-line me-0 me-sm-1 d-inline-block d-sm-none" />
                                <span className="d-none d-sm-inline-block">Edit</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <EditFrequency frequencyData={frequencyData} />
        </div>
    );
}